export default "__VITE_ASSET__4308ec6c__"